module.exports = __webpack_public_path__ + "static/media/qr-arrow.b4f67b4d.svg";